<template>
    <div id="content" :class="{checkout: isCheckout}">
        <Header v-if="isCheckout" :title="$t('checkout_step', {checkoutStep: checkout.orderAsGuest ? 2 : 1})" :info="$t('auth.login')" @close-checkout="closeCheckout"/>
        <div class="container">
            <template v-if="checkout.orderAsGuest">
                <div class="row">
                    <div class="col-md-8 offset-md-2">
                        <login :hybrid-auth="hybridAuth" :hide-forgot-password-link="false"/>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="row">
                    <div :class="[`col-md-${hybridAuth ? 12 : 8}`, {'offset-md-2': !hybridAuth}]">
                        <login :hybrid-auth="hybridAuth" :hide-forgot-password-link="false"/>
                    </div>
                </div>
            </template>
        </div>
        <Footer v-if="isCheckout" :step="{checkoutStep: checkout.orderAsGuest ? 2 : 1}" :auth-page="true"/>
        <powered-by v-if="!isCheckout && hasPoweredBy"/>
    </div>
</template>

<style lang="scss" scoped>
    #content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 130px 0 30px;

        &.checkout {
            padding-bottom: 130px;
        }
    }
</style>

<script>
  import Login from '../components/Login.vue';
  import Header from '../components/checkout/partials/Header.vue';
  import Footer from '../components/checkout/partials/Footer.vue';
  import PoweredBy from '../components/PoweredBy.vue';

  import login from 'src/mixins/loginPage';

  export default {
    mixins: [login],
    components: {
      Login,
      Header,
      Footer,
      PoweredBy,
    },
  };
</script>
